import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Form, Space, Tag, Tooltip } from 'antd'
import get from 'lodash.get'
import React, { useEffect, useMemo, useState } from 'react'
import dayjs from 'dayjs'
import { hasPermission } from '../../config-func'
import {
  ACTION_MODE,
  OPTIONS_OBJECT_POST,
  OPTIONS_PACKAGE_POST,
  PAGE_SIZE_OPTIONS
} from '../../configData'
import {
  deletePakagePostNew,
  getPakagePost,
  getPakagePostNew,
  pakagePostAdd,
  pakagePostAddNew,
  pakagePostDetail,
  pakagePostDetailNew,
  pakagePostUpdate,
  pakagePostUpdateNew
} from '../../services/pakage-post'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import FilterForm from './FilterForm'
import FormPost from './FormPost'
import { OPTIONS_WEB_FEE } from './configs'
import {
  getAllSelectionsList,
  getListSelectionByCategories
} from '../../services/selection-list-service'
import { PRODUCT_TYPE_WEB_FEE, ProductType } from '../PostManagement/configs'
import {
  buildSubProductTypeFromCategory,
  getSubProductType,
  mapSelectionByCategory
} from '../../utils/helpers'
import Loading from '../Loading'

const DEMAND_OPTIONS = [
  { value: 'sell', name: 'Bán' },
  { value: 'rent', name: 'Thuê' },
  { value: 'buying', name: 'Tìm mua' },
  { value: 'renting', name: 'Tìm thuê' }
]

const WebFeeManagement = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [listAllSelections, setListAllSelections] = useState([])
  const [postDateOptions, setPostDateOptions] = useState([]) // Options for post date
  const [demandOps, setDemandOps] = useState([])
  const [typeOfRealEstateOps, setTypeOfRealEstateOps] = useState([])
  const [filters, setFilters] = useState({
    currentPage: 0,
    pageSize: 10
  })

  const handleSearch = () => {
    if (filters.currentPage === 0) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 0 }))
    }
  }

  async function fetchData() {
    setLoading(true)

    let _dataSource = []
    let _total = 0

    const params = {
      page: filters.currentPage,
      size: filters.pageSize,
      packageName: filters.packageName || '',
      // status: filters.status || '',
      type: filters.type || '',
      demand: filters.demand || '',
      propertyType: filters.propertyType ? String(filters.propertyType) : '',
      postType: filters.postType ? String(filters.postType) : '',
      realEstateType: Array.isArray(filters.realEstateType)
        ? filters.realEstateType.map((i) => String(i)).join(',')
        : filters.realEstateType
        ? String(filters.realEstateType)
        : '',
      timeEx: filters.timeEx || ''
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await getPakagePostNew(cleanedData)
      _total = response?.paging?.totalElements
      _dataSource = response?.data
      // }
    } catch (error) {
      openNotification(
        'error',
        error?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
      setTotal(_total)
      setDataSource(_dataSource)
    }
  }
  const SUB_PRODUCT_TYPE_DYNAMIC = useMemo(
    () =>
      buildSubProductTypeFromCategory(listAllSelections, [
        'APARTMENT_BDS',
        'BUILDING_BDS',
        'GROUND_BDS',
        'REAL_ESTATE_BDS'
      ]),
    [listAllSelections]
  )
  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, filters.reset])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        filters.currentPage * filters.pageSize + index + 1
    },
    {
      title: 'Loại thu phí',
      dataIndex: 'feeType',
      key: 'feeType',
      width: 150,
      render: (_, record) => {
        return (
          <div>
            {OPTIONS_WEB_FEE.find((item) => item.value === record.feeType)
              ?.name || ''}
          </div>
        )
      }
    },
    {
      title: 'Tên gói',
      dataIndex: 'name',
      key: 'name',
      width: 150,
      render: (_, record) => {
        return (
          <div>
            {record.feeType === 'PACKAGE'
              ? record.packageProperties?.name
              : record.clickProperties?.identification || '-'}
          </div>
        )
      }
    },
    // {
    //   title: 'Độ ưu tiên',
    //   dataIndex: 'order',
    //   key: 'order',
    //   width: 150,
    //   render: (_, record) => {
    //     return (
    //       <div>
    //         {record.feeType === 'PACKAGE'
    //           ? record.packageProperties?.priority
    //           : record.clickProperties?.priority || ''}
    //       </div>
    //     )
    //   }
    // },

    {
      title: 'Nhu cầu',
      dataIndex: 'demand',
      key: 'demand',
      width: 150,
      render: (_, record) => {
        const demandValue =
          record.feeType === 'PACKAGE'
            ? record.packageProperties?.demand
            : record.clickProperties?.demand
        const demandOption = DEMAND_OPTIONS.find(
          (item) => item.value === demandValue
        )
        return <div>{demandOption?.name || demandValue || ''}</div>
      }
    },

    {
      title: 'Loại BĐS',
      dataIndex: 'propertyType',
      key: 'propertyType',
      width: 150,
      render: (_, record) => {
        const propertyTypeValue =
          record.feeType === 'PACKAGE'
            ? record.packageProperties?.propertyType
            : record.clickProperties?.propertyType

        const propertyTypeOption = ProductType.find(
          (item) => item.value == propertyTypeValue
        )
        return <div>{propertyTypeOption?.label || propertyTypeValue || ''}</div>
      }
    },

    {
      title: 'Loại hình BĐS',
      dataIndex: 'realEstateType',
      key: 'realEstateType',
      width: 150,
      render: (_, record) => {
        const realEstateTypeValue =
          record.feeType === 'PACKAGE'
            ? record.packageProperties?.realEstateType
            : record.clickProperties?.realEstateType
        const propertyTypeValue =
          record.feeType === 'PACKAGE'
            ? record.packageProperties?.propertyType
            : record.clickProperties?.propertyType

        if (!realEstateTypeValue || !Array.isArray(realEstateTypeValue)) {
          return <div>{realEstateTypeValue || ''}</div>
        }

        const labels = realEstateTypeValue
          .map((value) => {
            const option = (
              getSubProductType(propertyTypeValue, SUB_PRODUCT_TYPE_DYNAMIC) ||
              []
            ).find((item) => item.value == value)
            return option?.label || value
          })
          .filter(Boolean)

        return <div>{labels.join(', ') || ''}</div>
      }
    },

    {
      title: 'Thời gian',
      dataIndex: 'timeEx',
      key: 'timeEx',
      width: 100,
      render: (_, record) => {
        if (record.feeType === 'PACKAGE') {
          return (
            <div style={{ textAlign: 'center' }}>
              {record.packageProperties?.timeEx || ''}
            </div>
          )
        } else if (record.feeType === 'CLICK') {
          return (
            <div style={{ textAlign: 'center' }}>
              {record.clickProperties?.timeEx || ''}
            </div>
          )
        }
      }
    },
    // {
    //   title: 'Đối tượng',
    //   dataIndex: 'targetAudience',
    //   key: 'targetAudience',
    //   width: 150,
    //   render: (_, record) => {
    //     if (record.feeType === 'PACKAGE') {
    //       return (
    //         <div>
    //           {OPTIONS_OBJECT_POST.find(
    //             (item) =>
    //               item.value === record?.packageProperties?.targetAudience
    //           )?.name || ''}
    //         </div>
    //       )
    //     }
    //   }
    // },

    // {
    //   title: 'Màu tiêu đề',
    //   dataIndex: 'title_color',
    //   key: 'title_color',
    //   width: 150
    // },
    // {
    //   title: 'Kiểu tiêu dề',
    //   dataIndex: 'font_type',
    //   key: 'font_type',
    //   width: 150
    // },
    // {
    //   title: 'Trạng thái',
    //   dataIndex: 'status',
    //   key: 'status',
    //   width: 150,
    //   render: (_, record) => {
    //     const item = OPTIONS_PACKAGE_POST.find(
    //       ({ value }) => value === record.status
    //     )
    //     return item ? (
    //       <Tag color={item.value === 1 ? 'green' : 'red'}>{item.name}</Tag>
    //     ) : null
    //   }
    // },

    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            <>
              {hasPermission('P82.2', permissions) && (
                <Tooltip title="Chỉnh sửa">
                  <Button
                    style={{ width: 32 }}
                    icon={<EditOutlined />}
                    onClick={() => {
                      setMode(ACTION_MODE.UPDATE)
                      getDetailPakageCommunity(record.id)
                    }}
                  />
                </Tooltip>
              )}
              {hasPermission('P82.3', permissions) && (
                <Tooltip title="Xóa">
                  <Button
                    style={{ width: 32 }}
                    icon={<DeleteOutlined style={{ color: 'red' }} />}
                    onClick={() =>
                      showConfirm({
                        title: 'Xác nhận xóa',
                        content: (
                          <div>
                            Bạn có chắc chắn muốn xóa{' '}
                            <b>
                              {record.packageProperties?.name ||
                                record.name ||
                                'gói này'}
                            </b>
                          </div>
                        ),
                        onOk: () => handleDelete(record.id)
                      })
                    }
                  />
                </Tooltip>
              )}
            </>
          </Space>
        )
      }
    }
  ]

  // Thêm sửa project
  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const { id, package_fee, fee_type, ...data } = values

      if (fee_type === 'PACKAGE') {
        const package_properties = {
          name: data.name || '',
          demand: data.demand,
          status: data.status ? 'ACTIVE' : 'DEACTIVE',
          timeEx: data.timeEx ? String(data.timeEx) : '',
          priority: data.priority ? String(data.priority) : '',
          promotion: data.promotion ? String(data.promotion) : '',
          numberOfPic: data.numberOfPic ? String(data.numberOfPic) : '',
          numberOfEdit: data.numberOfEdit ? String(data.numberOfEdit) : null,
          propertyType: data.propertyType ? String(data.propertyType) : '',
          originalPrice: data.originalPrice ? String(data.originalPrice) : '',
          realEstateType: Array.isArray(data.realEstateType)
            ? data.realEstateType.map((item) => String(item))
            : [],
          identification: data.identification || 'INDIVIDUAL',
          targetAudience: data.identification || 'INDIVIDUAL'
        }

        // Tạo data object với package_properties
        const formattedData = {
          // ...data,
          feeType: fee_type,
          packageProperties: package_properties
        }

        const formattedDataUpdate = {
          feeType: fee_type,
          id: id || undefined,
          packageProperties: { ...package_properties }
        }

        const res =
          mode == ACTION_MODE.ADD
            ? await pakagePostAddNew(formattedData)
            : await pakagePostUpdateNew(formattedDataUpdate)

        form.resetFields()
        setIsModalOpen(false)
        fetchData()
        openNotification(
          'success',
          mode == ACTION_MODE.ADD
            ? 'Tạo mới cấu hình gói tin đăng Web thành công !'
            : 'Cập nhật cấu hình gói tin đăng Web thành công !'
        )
      } else if (fee_type === 'CLICK') {
        // Format dữ liệu theo ClickProperties cho CLICK
        const clickProperties = {
          demand: data.demand || '',
          status: data.status ? 'ACTIVE' : 'DEACTIVE',
          promotion: data.promotion ? String(data.promotion) : '',
          propertyType: data.propertyType ? String(data.propertyType) : '',
          originalPrice: data.originalPrice ? String(data.originalPrice) : '',
          identification: data.name || '', // Tên gói dùng làm identification
          realEstateType: Array.isArray(data.realEstateType)
            ? data.realEstateType.map((item) => String(item))
            : []
        }

        // Tạo data object với clickProperties
        const formattedData = {
          id: id || undefined,
          feeType: fee_type,
          clickProperties: clickProperties
        }

        const res =
          mode == ACTION_MODE.ADD
            ? await pakagePostAddNew(formattedData)
            : await pakagePostUpdateNew(formattedData)

        form.resetFields()
        setIsModalOpen(false)
        fetchData()
        openNotification(
          'success',
          mode == ACTION_MODE.ADD
            ? 'Tạo mới cấu hình gói tin đăng Web thành công !'
            : 'Cập nhật cấu hình gói tin đăng Web thành công !'
        )
      }
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }
  const [detailForm, setDetailForm] = useState({})
  // Chi tiết dự án
  const getDetailPakageCommunity = async (id) => {
    setLoading(true)
    try {
      const res = await pakagePostDetailNew(id)

      if (res && res.data) {
        setIsModalOpen(true)
        const values = res.data
        const feeType = values.feeType

        if (feeType === 'PACKAGE') {
          const packageProperties = values.packageProperties || {}
          // Map dữ liệu từ API vào form cho PACKAGE
          form.setFieldsValue({
            id: values.id,
            fee_type: values.feeType,
            name: packageProperties.name || '',
            priority: packageProperties.priority || '',
            identification:
              packageProperties.identification ||
              packageProperties.targetAudience ||
              'INDIVIDUAL',
            numberOfEdit: Number(packageProperties.numberOfEdit) || '',
            numberOfPic: Number(packageProperties.numberOfPic) || '',
            demand: packageProperties.demand || '',
            propertyType: Number(packageProperties.propertyType) || '',
            realEstateType: Array.isArray(packageProperties.realEstateType)
              ? packageProperties.realEstateType.map((item) => Number(item))
              : [],
            timeEx: packageProperties.timeEx || '',
            originalPrice: Number(packageProperties.originalPrice) || '',
            promotion: Number(packageProperties.promotion) || '',
            status: packageProperties.status === 'ACTIVE'
          })
        } else if (feeType === 'CLICK') {
          const clickProperties = values.clickProperties || {}
          // Map dữ liệu từ API vào form cho CLICK
          form.setFieldsValue({
            id: values.id,
            fee_type: values.feeType,
            name: clickProperties.identification || '',
            demand: clickProperties.demand || '',
            propertyType: Number(clickProperties.propertyType) || '',
            realEstateType: Array.isArray(clickProperties.realEstateType)
              ? clickProperties.realEstateType.map((item) => Number(item))
              : [],
            originalPrice: Number(clickProperties.originalPrice) || '',
            promotion: Number(clickProperties.promotion) || '',
            status: clickProperties.status === 'ACTIVE'
          })
        }

        setDetailForm(values)
      } else {
        openNotification('error', 'Có lỗi xảy ra, Vui lòng thử lại')
      }
    } catch (err) {
      openNotification('error', 'Có lỗi xảy ra khi lấy chi tiết cấu hình phí')
    } finally {
      setLoading(false)
    }
  }

  // Xóa project
  const handleDelete = async (id) => {
    // const body = {
    //   ids: [ids]
    // }
    setLoading(true)
    try {
      const res = await deletePakagePostNew(id)
      fetchData()
      openNotification(
        'success',
        res.message == 'Success'
          ? 'Xóa cấu hình thu phí Web thành công !'
          : res.message || 'Đã có lỗi xảy ra'
      )
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }
  const getSelection = async () => {
    try {
      const res = await getAllSelectionsList()
      const data = res?.data || res || []
      const filteredData = data
        ?.filter(
          (item) => item.category === 'POST_DAY' && !isNaN(Number(item.value))
        )
        .sort((a, b) => Number(a.value) - Number(b.value))
      setListAllSelections(res || [])
      setPostDateOptions(filteredData || [])
    } catch (err) {}
  }

  useEffect(() => {
    setTimeout(() => {
      mapSelectionByCategory(listAllSelections, [
        {
          // nhu cầu
          category: 'DEMAND',
          setState: setDemandOps
        },
        {
          // loại bất động sản
          category: 'TYPE_OF_REAL_STATE',
          setState: setTypeOfRealEstateOps
        }
      ])
    }, 0)
  }, [listAllSelections])
  useEffect(() => {
    getSelection()
  }, [])
  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <FilterForm
          handleSearch={handleSearch}
          setFilters={setFilters}
          fetchData={fetchData}
          postDateOptions={postDateOptions}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Quản lý dự án</h2> */}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            {/* <Button
              type="primary"
              key="primary"
              onClick={() => {
                setIsModalImportOpen(true)
              }}
            >
              <PlusOutlined /> Import Excel
            </Button> */}
            {hasPermission('82.1', permissions) && (
              <Button
                type="primary"
                // htmlType="submit"
                onClick={() => {
                  setIsModalOpen(true)
                  setMode(ACTION_MODE.ADD)
                }}
              >
                <PlusOutlined />
                Thêm mới
              </Button>
            )}
          </div>
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          data={dataSource}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          pagination={{
            current: filters.currentPage + 1,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 0
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page - 1 }))
            },
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE
            ? 'Chỉnh sửa thu phí Web'
            : mode == 'ADD'
            ? 'Thêm mới thu phí Web'
            : 'Xem chi tiết'
        }
        visible={isModalOpen}
        centered
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {}
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={mode == 'VIEW' ? [''] : ''}
        width={1200}
      >
        <FormPost
          form={form}
          mode={mode}
          detailForm={detailForm}
          demandOps={demandOps}
          postDateOptions={postDateOptions}
          typeOfRealEstateOps={typeOfRealEstateOps}
          listAllSelections={listAllSelections}
        />
      </ModalCustom>
      <ModalConfirm />
    </div>
  )
}

export default WebFeeManagement
